import { SubscriptionCard, PersonalInfoCard, PhoneCard } from './components'
import { FidelityBanner } from '../fidelity-banner'
import './style.scss'

export function PlanInfo() {
  return (
    <div className='plan-info-section'>
      <FidelityBanner />
      <h2 className='section-title'>Informações do meu plano</h2>
      <div className='cards-wrapper'>
        <SubscriptionCard />
        <PersonalInfoCard />
        <PhoneCard />
      </div>
    </div>
  )
}
